<template>
  <div class="history">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs :items="['Download History']"></v-breadcrumbs>
          <!-- <v-breadcrumbs v-t="'Receipt'"></v-breadcrumbs>  -->
        </v-sheet>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="me-auto">
        <v-sheet class="pa-2">
          <v-text-field
            append-inner-icon="mdi-close-circle"
            append-icon="mdi-magnify"
            density="compact"
            label="Search"
            variant="solo"
            hide-details
            single-line
            dense
            v-model="query"
            @click:append-inner="resetData"
            @click:append="searchRecord"
          ></v-text-field>
        </v-sheet>
      </v-col>
      <!-- FOR USER  open a dialog to select all or an acquirer before exporting-->
      <!-- <v-col cols="auto mt-2">
        <v-sheet>
          <v-btn variant="text" @click="compose_select_acquirer" v-if="this.global_permissions.includes('ROLE_USER_ADMIN') || this.global_permissions.includes('ROLE_USER_ASSIST') ">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>            
          </v-btn>
        </v-sheet>
      </v-col> -->
      <!-- FOR ADMIN -->
       <!-- <v-col cols="auto mt-2">
        <v-sheet>
          <v-btn variant="text" @click="compose_select_organization" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER') ">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>            
          </v-btn>
        </v-sheet>
      </v-col> -->
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else class="mt-4">
      <v-data-table
        v-model:expanded="expanded"
        :headers="headers"
        :items="records"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <!-- FOR EXPANSION -->
        <template v-slot:expanded-row="{ columns, item }">
          <!-- <tr>
            <td :colspan="columns.length">Device ID : {{ item.raw.data.id }}</td>
          </tr> -->
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_operations") }} : {{ item.raw.data.allowedOperations }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_settlement_time") }} : {{ item.raw.data.stmTime }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_settlement_days") }} : {{ item.raw.data.settleDays }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_no_of_receipts") }} : {{ item.raw.data.receiptNumber }}
            </td>
          </tr>          
          <tr v-if=" this.featureFlags.includes('DUAL_CURRENCY') || this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER')">           
            <td :colspan="columns.length">
              {{ $t("device_dual_currency") }} : {{ item.raw.data.doubleCurrency }}
            </td>
          </tr>
          <tr v-if=" this.featureFlags.includes('RECEIPT_BARCODE') || this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER')">           
            <td :colspan="columns.length">
              {{ $t("device_barcode") }} : {{ item.raw.data.receiptBarcode }}
            </td>
          </tr>
          <!-- <tr>
            <td :colspan="columns.length">
              Downloadable : {{ item.raw.data.downloadEnable }}
            </td>
          </tr> -->
          <!-- <tr>
            <td :colspan="columns.length">
              Merchant Pwd : {{ item.raw.data.merchantPwd }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              Settings Pwd : {{ item.raw.data.settingsPwd }}
            </td>
          </tr> -->
          <tr>
            <td :colspan="columns.length">
              Date Created :
              {{ formatDateList(item.raw.data.createdAt) }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              Created By : {{ item.raw.data.createdBy }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              Date Updated : {{ formatDateList(item.raw.data.updatedAt) }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              Updated By : {{ item.raw.data.updatedBy }}
            </td>
          </tr>
        </template>

        <template v-slot:item.tid="{ item }">
          <p v-for="it in item.raw.data.merchantDetails" :key="it.id">
            {{ it.tid }}
          </p>
        </template>

        <template v-slot:item.mid="{ item }">
          <p v-for="it in item.raw.data.merchantDetails" :key="it.id">
            {{ it.mid }}
          </p>
        </template>

        <template v-slot:item.cvm="{ item }">
          <p v-for="it in item.raw.data.merchantDetails" :key="it.id">
            {{ it.cvm }}
          </p>
        </template>

        <template v-slot:item.currencyName="{ item }">
          <p v-for="it in item.raw.data.merchantDetails" :key="it.id">
            {{ it.currency.currencyName }}
          </p>
        </template>

        <template v-slot:item.downloadStatus="{ item }">
          <p v-if="item.raw.downloadStatus" >Active</p>
          <p v-else >Downloaded</p>        
        </template>

        <!-- Expiry Updated -->
        <!-- <template v-slot:item.updatedAt="{ item }">
          {{ formattedDate(item.raw.updatedAt) }}
        </template> -->

        <!-- <template v-slot:item.actions="{ item }">
          <v-tooltip text="Delete" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="red"
                small
                @click="compose_delete(item.raw.id)"
                v-if="this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template> -->

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- DELETE RECEIPT DIALOG -->
    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">Delete File</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          Are you sure you want to delete this file?
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteRecord">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END DELETE RECEIPT DIALOG -->

    <!-- SELECT ACQUIRER FOR EXPORT -->
    <v-dialog v-model="dialog_select_acquirer" persistent width="700">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Export Data</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                                 
                      <!-- <v-select
                        :items="optionsWithSelectAll"
                        item-title="acquirerName"
                        item-value="acquirerId"                          
                        label="Select Acquirer"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select> --> 
                      <v-select
                        :items="acquirer"
                        item-title="acquirerName"
                        item-value="acquirerId"                          
                        label="Select Acquirer"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>                     
                    </v-col>                 
                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_select_acquirer = false">{{
                $t("Close")
              }}</v-btn>
              
              <v-btn variant="text" @click="exportRecordData(this.select_acquirer.f_acquirerId)">
                <span class="mr-1">{{ $t("export") }}</span>
                <v-icon color="grey-darken-1">mdi mdi-download</v-icon>                
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END SELECT ACQUIRER FOR EXPORT -->

    <!-- SELECT ORGANIZATION FOR EXPORT -->
    <v-dialog v-model="dialog_select_organization" persistent width="700">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Export Data</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                                 
                      <!-- <v-select
                        :items="orgWithSelectAll"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select organization"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>   -->
                      <v-select
                        :items="organization"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select organization"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>                      
                    </v-col>                 
                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_select_organization = false">{{
                $t("Close")
              }}</v-btn>
              
              <v-btn variant="text" @click="exportRecordDataForAdmin(this.select_acquirer.f_acquirerId)">
                <span class="mr-1">{{ $t("export") }}</span>
                <v-icon color="grey-darken-1">mdi mdi-download</v-icon>                
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END SELECT ORGANIZATION FOR EXPORT -->

  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "DownloadHistory",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      //acquirers: [],
      records: [],
      exportDevices: [],
      acquirer: [],
      organization: [], 
      //records1: [ { id: "", deviceSN: "", createdAt: "" , data: {} } ],

      //organization: [],
      //dialog: false,
      //dialog_update: false,
      dialog_delete: false,
      dialog_select_acquirer: false,
      dialog_select_organization: false,

      recordId: "",
      record_response: [],
      search: "",
      loading: true,

      expanded: [],

      headers: [
        {
          title: "Device SN",
          align: "start",
          sortable: false,
          key: "deviceSN",
        },
        { title: "", key: "data-table-expand" },
        { title: "Merchant Name", key: "data.merchant.merchantName" },
        { title: "Merchant Address", key: "data.merchant.merchantAddress" },
        { title: "TID", key: "tid", sortable: true },
        { title: "MID", key: "mid", sortable: true },
        { title: "CVM Limit", key: "cvm", sortable: true },
        { title: "Currency", key: "currencyName" },

        //{ title: "Data", key: "data.id" },
        // { title: "Updated", key: "createdAt" },
        { title: "Download Status", key: "downloadStatus" },
        { title: "Updated", key: "updatedAt" },
        { title: "Acquirer", key: "data.merchant.acquirer.acquirerName" },

        //{ title: this.$t("Actions"), key: "actions", sortable: false, width: "100px" },
      ],

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",

      //FOR EXPORT
      json_fields: {
        "Serial Number": "deviceSN",
        "Download Status": "downloadStatus",
        "Date Updated": "updatedAt",
        "Acquirer": "data.merchant.acquirer.acquirerName",
        "Organization": "data.merchant.acquirer.organization.orgName",
      },

      //select acquirer
      select_acquirer: {
        f_acquirerId: "",        
      }, 

    };
  },

  created() {},

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      let count = Math.ceil(this.totalItems / this.itemsPerPage);

      return count;
    },

    optionsWithSelectAll(){
      return [{acquirerId: "all", acquirerName:"All"}, ...this.acquirer]
    },

    orgWithSelectAll(){
      return [{orgId: "all", orgName:"All"}, ...this.organization]
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },
  },

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    required(v) {
      return !!v || "Field is required";
    },

    compose_delete(id) {
      this.recordId = id;
      this.dialog_delete = true;
    },

    compose_select_acquirer() {
      this.dialog_select_acquirer = true;
      this.checkTokenExpiry();
      this.requests_handler3();
    },

    compose_select_organization() {
      this.dialog_select_organization = true;
      this.checkTokenExpiry();
      this.requests_handler4();
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    requests_handler4() {
      axios
        .all([
          axios.get(window.baseurl + "organizations", {            
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((org_response) => {
            // console.log("data1", acq_response.data);

            if (org_response.status == 200) {
              if (
                org_response.data.records != null &&
                org_response.data.records.length > 0
              ) {
                let i = 0;
                this.organization = []; //remove all items from array
                for (i = 0; i < org_response.data.records.length; i++) {
                  this.organization.push({
                    orgId: org_response.data.records[i].id,
                    orgName: org_response.data.records[i].orgName,
                  });
                  
                }
              }
            }
          })
        );
    }, //end of requests_handler4 method

    requests_handler3() {
      axios
        .all([
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((acq_response) => {
            // console.log("data1", acq_response.data);

            if (acq_response.status == 200) {
              if (
                acq_response.data.records != null &&
                acq_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirer = []; //remove all items from array
                for (i = 0; i < acq_response.data.records.length; i++) {
                  this.acquirer.push({
                    acquirerId: acq_response.data.records[i].id,
                    acquirerName: acq_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirer", this.acquirer)
                }
              }
            }
          })
        );
    }, //end of requests_handler3 method

    async deleteRecord() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "records/" + "" + this.recordId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );

        if (result.status == 204) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: "Download History Deleted" });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "records", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("record_object", result);

          //
          this.records = [];
          this.loading = false;
          if (result.data.records.length > 0) {
            for (let i = 0; i < result.data.records.length; i++) {
              // this.records.push({
              //       id: result.data.records[i].id,
              //       deviceSN: result.data.records[i].deviceSN,
              //       createdAt: result.data.records[i].createdAt,
              //       data: JSON.parse( result.data.records[i].data),
              //     });

              if (result.data.records[i].data != null) {
                this.records.push({
                  id: result.data.records[i].id,
                  deviceSN: result.data.records[i].deviceSN,
                  createdAt: result.data.records[i].createdAt,
                  updatedAt: result.data.records[i].updatedAt,
                  downloadStatus: result.data.records[i].downloadStatus,                  
                  data: JSON.parse(result.data.records[i].data),
                });
              } else if (result.data.records[i].configData != null) {
                this.records.push({
                  id: result.data.records[i].id,
                  deviceSN: result.data.records[i].deviceSN,
                  createdAt: result.data.records[i].createdAt,
                  updatedAt: result.data.records[i].updatedAt,
                  downloadStatus: result.data.records[i].downloadStatus,                  
                  data: JSON.parse(result.data.records[i].configData),
                });
              }
            }
          } else {
            this.records = [];
          }

          // console.log("record_object2", this.records);
          // console.log("UpdatedAt", this.records.createdAt);
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          // console.log("Org ID", this.orgId);
          result = await axios.get(
            window.baseurl + "records/org/" + this.orgId,
            {
              params: { page: page2 },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("records_object", result);
          //this.records = result.data.records;
          //
          this.records = [];
          this.loading = false;
          if (result.data.records.length > 0) {
            for (let i = 0; i < result.data.records.length; i++) {
              // this.records.push({
              //   id: result.data.records[i].id,
              //   deviceSN: result.data.records[i].deviceSN,
              //   createdAt: result.data.records[i].createdAt,
              //   data: JSON.parse(result.data.records[i].data),
              // });
              if (result.data.records[i].data != null) {
                this.records.push({
                  id: result.data.records[i].id,
                  deviceSN: result.data.records[i].deviceSN,
                  createdAt: result.data.records[i].createdAt,
                  updatedAt: result.data.records[i].updatedAt,
                  downloadStatus: result.data.records[i].downloadStatus,
                  data: JSON.parse(result.data.records[i].data),
                });
              } else if (result.data.records[i].configData != null) {
                this.records.push({
                  id: result.data.records[i].id,
                  deviceSN: result.data.records[i].deviceSN,
                  createdAt: result.data.records[i].createdAt,
                  updatedAt: result.data.records[i].updatedAt,
                  downloadStatus: result.data.records[i].downloadStatus,
                  data: JSON.parse(result.data.records[i].configData),
                });
              }
            }
          } else {
            this.records = [];
          }
          // console.log("records_object2", this.records);
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
        }
      } catch (error) {
        //console.log("error", error);
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchRecord() {
      let result;
      let page2 = this.page - 1;
      this.checkTokenExpiry();
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "records/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("record_object_search", result);
          //
          this.records = [];
          if (result.data.records.length > 0) {
            for (let i = 0; i < result.data.records.length; i++) {
              // this.records.push({
              //   id: result.data.records[i].id,
              //   deviceSN: result.data.records[i].deviceSN,
              //   createdAt: result.data.records[i].createdAt,
              //   data: JSON.parse(result.data.records[i].data),
              // });
              if (result.data.records[i].data != null) {
                this.records.push({
                  id: result.data.records[i].id,
                  deviceSN: result.data.records[i].deviceSN,
                  createdAt: result.data.records[i].createdAt,
                  updatedAt: result.data.records[i].updatedAt,
                  downloadStatus: result.data.records[i].downloadStatus,
                  data: JSON.parse(result.data.records[i].data),
                });
              } else if (result.data.records[i].configData != null) {
                this.records.push({
                  id: result.data.records[i].id,
                  deviceSN: result.data.records[i].deviceSN,
                  createdAt: result.data.records[i].createdAt,
                  updatedAt: result.data.records[i].updatedAt,
                  downloadStatus: result.data.records[i].downloadStatus,
                  data: JSON.parse(result.data.records[i].configData),
                });
              }
            }
          } else {
            this.records = [];
          }
          // console.log("record2_object_search", result);
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          result = await axios.get(
            window.baseurl + "records/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("record_search_object", result);
          //
          this.records = [];
          if (result.data.records.length > 0) {
            for (let i = 0; i < result.data.records.length; i++) {
              // this.records.push({
              //   id: result.data.records[i].id,
              //   deviceSN: result.data.records[i].deviceSN,
              //   createdAt: result.data.records[i].createdAt,
              //   data: JSON.parse(result.data.records[i].data),
              // });

              if (result.data.records[i].data != null) {
                this.records.push({
                  id: result.data.records[i].id,
                  deviceSN: result.data.records[i].deviceSN,
                  createdAt: result.data.records[i].createdAt,
                  updatedAt: result.data.records[i].updatedAt,
                  downloadStatus: result.data.records[i].downloadStatus,
                  data: JSON.parse(result.data.records[i].data),
                });
              } else if (result.data.records[i].configData != null) {
                this.records.push({
                  id: result.data.records[i].id,
                  deviceSN: result.data.records[i].deviceSN,
                  createdAt: result.data.records[i].createdAt,
                  updatedAt: result.data.records[i].updatedAt,
                  downloadStatus: result.data.records[i].downloadStatus,
                  data: JSON.parse(result.data.records[i].configData),
                });
              }
            }
          } else {
            this.records = [];
          }
          // console.log("record2_object_search", result);
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.response.data.message });
      }
    },

    //Export     //THE WHOLE EXPORT FUNCTIONS NOT IN USE FOR DOWNLOAD , BUT KEEPING FOR FUTURE IMPLEMENTATION

    async downloadExcel(acquirerId) {
      this.loading = true;
      try {
       
        const response = await fetch(window.baseurl + "records/export/acq/" + acquirerId, {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          link.setAttribute('download', 'merchant_data.xlsx');  // Set the file name
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async downloadExcel2(orgId) {
      this.loading = true;
      try {
        
        const response = await fetch(window.baseurl + "records/export/org/" + orgId, {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {          
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          link.setAttribute('download', 'merchant_data.xlsx');  // Set the file name
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async downloadExcelAdmin() {
      this.loading = true;
      try {
        
        const response = await fetch(window.baseurl + "records/export/all", {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          link.setAttribute('download', 'merchant_data.xlsx');  // Set the file name
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async exportRecordData(id) {      
      console.log("merchant_object44", id);      
      if(id == "all"){        
        this.downloadExcel2(this.orgId);
      }else{
        this.downloadExcel(id);
      }
      this.dialog_select_acquirer = false;     
    },

    async exportRecordDataForAdmin(id) {      
      console.log("merchant_object44", id);      
      if(id == "all"){        
        this.downloadExcelAdmin();
      }else{
        this.downloadExcel2(id);
      }
      this.dialog_select_organization = false;
    },

    formattedDate(dateString) {
      const date = new Date(dateString);
      return (
        date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) +
        " " +
        date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    },

    /* formatDateList(dateArray) {
      // Create a new Date object
      const date = new Date(
        dateArray[0],
        dateArray[1] - 1,
        dateArray[2],
        dateArray[3],
        dateArray[4],
        dateArray[5],
        Math.floor(dateArray[6] / 1000000)
      );

      // Format the date to a readable string
      return this.formattedDate(date);
    }, */


    formatDateList(value) {
      if (!value) return '';

      // 1️⃣ ISO string: "2024-11-12T10:21:03.444337"
      if (typeof value === 'string') {
        // trim microseconds → milliseconds
        const safe = value.replace(/(\.\d{3})\d+/, '$1');
        const date = new Date(safe);
        return isNaN(date.getTime()) ? '' : this.formattedDate(date);
      }

      // 2️⃣ Array: [yyyy, mm, dd, hh, mm, ss, nanos]
      if (Array.isArray(value)) {
        const [
          year,
          month,
          day,
          hour = 0,
          minute = 0,
          second = 0,
          fraction = 0
        ] = value;

        let milliseconds = 0;

        if (fraction > 1_000_000) {
          milliseconds = Math.floor(fraction / 1_000_000); // ns → ms
        } else if (fraction > 1_000) {
          milliseconds = Math.floor(fraction / 1_000);     // µs → ms
        } else {
          milliseconds = fraction;                          // ms
        }

        const date = new Date(
          year,
          month - 1,
          day,
          hour,
          minute,
          second,
          milliseconds
        );

        return isNaN(date.getTime()) ? '' : this.formattedDate(date);
      }

      return '';
    }


  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get user list
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
